
export class Modules {
    public static readonly RegulationSurvey	= 310021;
    public static readonly RegulatoryStandardsAnnualReturn	= 310022;
    public static readonly SocialHousingCharter	= 310026;
    public static readonly TenantSatisfactionMeasures	= 310025;
    public static readonly KeyPerformanceIndicators	= 310023;
    public static readonly JointCosts = 310020;
    public static readonly ExtraInsights = 310024;
    public static readonly HeadlineFinancials = 310010;
}

export class SectionSortOrder {
    static readonly order = [
        Modules.RegulationSurvey,
        Modules.RegulatoryStandardsAnnualReturn,
        Modules.SocialHousingCharter,
        Modules.TenantSatisfactionMeasures,
        Modules.KeyPerformanceIndicators,
        Modules.ExtraInsights,
        Modules.HeadlineFinancials,
        Modules.JointCosts,
    ];
}